import { render, staticRenderFns } from "./PublicCourses.vue?vue&type=template&id=f62a512c&scoped=true"
import script from "./PublicCourses.vue?vue&type=script&lang=js"
export * from "./PublicCourses.vue?vue&type=script&lang=js"
import style0 from "./PublicCourses.vue?vue&type=style&index=0&id=f62a512c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62a512c",
  null
  
)

export default component.exports